import React from 'react'
import * as PropTypes from 'prop-types'
import classNames from 'classnames'
import { ReactComponent as CrossIcon } from '~shared/assets/img/icons/cross-icon.svg'
import { MaterialIcon } from '~src/new/shared/ui/MaterialIcon/MaterialIcon'
import cls from './pin-filter.module.scss'
import Text from '~src/new/shared/ui/Text/Text'

/**
 * @param {{label: string, onClick: Function, variant?: 'outline'|'dark'|'active'|'reset', className?: string,
 *   closeIconName?: 'cancel'|'close', ellipsis?: boolean}} props
 * @returns {JSX.Element}
 */
export const PinFilter = React.forwardRef((props, ref) => {
  const {
    label,
    onClick,
    variant = 'outline',
    className,
    closeIconName = 'cancel',
    ellipsis = false,
  } = props
  const isReset = variant === 'reset'
  const Component = isReset ? 'button' : 'div'

  return (
    <Component
      ref={ref}
      type={isReset ? 'button' : undefined}
      onClick={isReset ? onClick : undefined}
      className={classNames(
        cls.pin,
        {
          [cls.dark]: variant === 'dark',
          [cls.active]: variant === 'active',
          [cls.reset]: variant === 'reset',
        },
        className,
      )}
    >
      <Text variant="body-small" className={classNames({ [cls.ellipsis]: ellipsis })}>
        {label}
      </Text>
      {variant === 'outline' ? (
        <CrossIcon onClick={onClick} />
      ) : (
        <MaterialIcon
          name={closeIconName}
          size={16}
          onClick={isReset ? undefined : onClick}
          className={classNames(cls.closeIcon, { [cls.closeIconReset]: variant === 'reset' })}
        />
      )}
    </Component>
  )
})

PinFilter.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['outline', 'dark', 'active', 'reset']),
  className: PropTypes.string,
  closeIconName: PropTypes.oneOf(['cancel', 'close']),
  ellipsis: PropTypes.bool,
}
